import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';

import { SignaturePadOptions } from '@lockton-apps/shared/ui/lui';

import { FieldTypeDirective } from '../form-field-wrapper/field.type.directive';

interface SignaturePadProps extends FormlyFieldProps {
  signatureOptions?: SignaturePadOptions;
  readonly?: boolean;
}

@Component({
    selector: 'lockton-apps-signature-pad-type',
    templateUrl: './signature-pad-type.component.html',
    styleUrls: ['./signature-pad-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SignaturePadTypeComponent extends FieldTypeDirective<
  FieldTypeConfig<SignaturePadProps>
> {}
